import { render, staticRenderFns } from "./InventoryReport.vue?vue&type=template&id=60fb9e64"
import script from "./InventoryReport.vue?vue&type=script&lang=js"
export * from "./InventoryReport.vue?vue&type=script&lang=js"
import style0 from "./InventoryReport.vue?vue&type=style&index=0&id=60fb9e64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports